import React, { Component } from 'react';
import couterpart from 'counterpart';
import {
    WORK_ORDER_PRINT_IMAGE_HEIGHT,
    WORK_ORDER_PRINT_IMAGE_WIDTH
} from '../constants';

import WorkOrderDataService from '../services/WorkOrderDataService';
import ImageViewer from './ImageViewer';
import '../css/style.css';

class WorkOrderImagesPrint extends Component {
  constructor () {
    super();
    this.state = {
      images: []
    };
  }

  componentDidMount () {
    WorkOrderDataService.retrieveImagesOfWorkOrder(this.props.workOrderId).then(data => {
      this.setState({ images:  data});
    });
  }

  render() {
    const work_order_image_face = couterpart.translate('work_order_image_face');
    const work_order_image_back = couterpart.translate('work_order_image_back');
    
    if (this.state.images.length === 1){
      return (
        <div className="woContainerImagesInternal">
          <div className="woCell woImageCell"><b>{work_order_image_face}</b></div>
          <div className="woCell woImageCell"><ImageViewer width={WORK_ORDER_PRINT_IMAGE_WIDTH} 
                  height={WORK_ORDER_PRINT_IMAGE_HEIGHT} data={this.state.images[0].content}/></div>
        </div>     
      )
    }else if (this.state.images.length >=2){
      return (
          <div className="woContainerImagesInternal">
            <div className="woCell woImageCell"><b>{work_order_image_face}</b></div>
            <div className="woCell woImageCell"><ImageViewer width={WORK_ORDER_PRINT_IMAGE_WIDTH} 
                    height={WORK_ORDER_PRINT_IMAGE_HEIGHT} data={this.state.images[0].content}/></div>
            <div className="woCell woImageCell"><b>{work_order_image_back}</b></div>
            <div className="woCell woImageCell"><ImageViewer width={WORK_ORDER_PRINT_IMAGE_WIDTH} 
                    height={WORK_ORDER_PRINT_IMAGE_HEIGHT} data={this.state.images[1].content}/></div>
          </div> 
      )      
    }else{
      return (
        <div className="woContainerImagesInternal">
          &nbsp;
        </div>     
      )
    }
  }
}

export default WorkOrderImagesPrint;